<div class="heading">{{title}}</div>

<div [fxLayout]="fxDirection" fxLayout.lt-lg="column" fxLayoutGap="20px">
  <div *ngFor="let item of items"
  class="item"
  fxFlex="grow">

    <advert-grid-item [entity]="item"></advert-grid-item>

  </div>
</div>